import { render } from "./guangMingAiHuModel.vue?vue&type=template&id=53ea9a04"
import script from "./guangMingAiHuModel.vue?vue&type=script&lang=js"
export * from "./guangMingAiHuModel.vue?vue&type=script&lang=js"

import "./guangMingAiHuModel.vue?vue&type=style&index=0&id=53ea9a04&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__